<template>
    <v-modal-slot size="sm">
        <template v-slot:modal-title>
            Roles permitidos
        </template>

        <template v-slot:modal-content>
            <div class="row">
                <template v-for="role in availableRoles" :key="role.id">
                    <div class="form-check" v-if="role.name !== 'administrador'">
                        <input class="form-check-input" type="checkbox" :value="role.id" :checked="templateRolesIds.includes(role.id)" :name="role.name" :id="role.name" @change="updateRole">
                        <label class="form-check-label" :for="role.name">
                            {{ formatRoleName(role.name) }}
                        </label>
                    </div>
                </template>
            </div>
        </template>

        <template v-slot:close-button>
            Cerrar
        </template>
    </v-modal-slot>
</template>

<script>

import VModalSlot from "../../../general/VModalSlot";
import {activateTemplateRole, deactivateTemplateRole} from "../../../../helpers/requests/RequestsTemplates";

export default {
    name: "TemplatesEditRolesUpdateModal",
    props: {
        templateId: {
            type: Number,
            required: true,
        },
        availableRoles: {
            type: Object,
            required: true,
        },
        templateRolesIds: {
            type: Array,
            required: true,
        }
    },
    components: {
        VModalSlot
    },
    data() {
        return {
            fields: require('../../../../config/form_fields.json'),
        }
    },
    async mounted() {

    },
    methods: {
        formatRoleName(name) {
            return name.charAt(0).toUpperCase() + name.slice(1).replaceAll('_', ' ');
        },
        async updateRole(e) {
            let roleId = e.target.value;

            if (e.target.checked) {
                await activateTemplateRole(this.templateId, roleId);
                this.$store.dispatch('app/setToastMessage', 'El rol elegido ahora puede utilizar la plantilla.');
            } else {
                await deactivateTemplateRole(this.templateId, roleId);
                this.$store.dispatch('app/setToastMessage', 'El rol ha sido desautorizado de la plantilla.');
            }
        }
    },
}
</script>
